// src/components/modal/MenuItemDetails/utils/themeUtils.ts
import type { NormalizedTheme } from "../types";
import { DEFAULT_THEME } from "../types";

/**
 * Normalizes a theme object by filling in missing properties with defaults
 */
export function normalizeTheme(inputTheme: any): NormalizedTheme {
  if (!inputTheme) return DEFAULT_THEME;

  return {
    primaryColor: inputTheme.primaryColor || DEFAULT_THEME.primaryColor,
    secondaryColor: inputTheme.secondaryColor || DEFAULT_THEME.secondaryColor,
    backgroundColor: inputTheme.backgroundColor || DEFAULT_THEME.backgroundColor,
    cardColor: inputTheme.cardColor || DEFAULT_THEME.cardColor,
    textColor: inputTheme.textColor || DEFAULT_THEME.textColor,
    borderColor: inputTheme.borderColor || DEFAULT_THEME.borderColor,
    borderRadius: inputTheme.borderRadius || DEFAULT_THEME.borderRadius,
    fontFamily: inputTheme.fontFamily || DEFAULT_THEME.fontFamily,
  };
}
